import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../shared/services/common/common.service';

@Injectable({
  providedIn: 'root'
})
export class ManageStaffService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient, 
    private commonService: CommonService
  ) {}

  /**
   * Get the staff list with dynamic parameters from login response
   * @param loginID User ID from login response
   * @param userType User type from login response
   * @param page Current page number
   * @param limit Items per page
   * @param role User role from login response
   * @returns Observable with staff data
   */
  getStaffList(loginID: number, userType: string, page: number, limit: number, role: string): Observable<any> {
    // Ensure all parameters are valid to prevent API 400 errors
    if (!loginID || !userType || !role) {
      throw new Error('Missing required parameters: loginID, log_UserType, or role');
    }
    
    // Build the URL with the query parameters
    const url = `${this.apiUrl}/user/stafflist`;
    
    // Create query parameters
    const params = {
      'loginID': loginID,
      'log_UserType': userType,
      'page_no': page.toString(),
      'limit': limit.toString(),
      'role': role
    };
    
    // Make the request with params
    return this.http.get<any>(url, { params });
  }
}